import * as angular from "angular";

const subTaskType = 'SubTaskGroup';

angular
  .module('bringoz.admin.tags')
  .constant('tagsConstants', {
    subTaskType: subTaskType
  });
